var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slider",
    staticClass: "Polaris-ColorPicker__AlphaPicker"
  }, [_c('div', {
    staticClass: "Polaris-ColorPicker__ColorLayer",
    style: (_vm.background)
  }), _vm._v(" "), _c('polaris-color-picker-slidable', {
    attrs: {
      "dragger-y": _vm.offset,
      "dragger-x": 0
    },
    on: {
      "change": _vm.onChange,
      "draggerheight": _vm.handleDraggerHeight
    }
  })], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de0591cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de0591cc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisColorPickerAlphaPicker.vue
// module id = 260
// module chunks = 0